export default function getBaseUri() {
    let origin = window.location.origin,
        base = (origin.indexOf('localhost') == -1) ? origin : 'https://prod-wordpress-ch.azurewebsites.net';
    return base;
  }
  